import { apiFetch } from '@ami/react/core';
const _baseEndPoint = 'customer-approvals';

export default class customerApprovalDocument {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name || '';
      this.customerApprovalId = item.customerApprovalId;
      this.fileKey = item.fileKey;
      this.fileName = item.fileName;
      return;
    }
    this.id = null;
    this.name = '';
    this.customerApprovalId = undefined;
    this.fileKey = undefined;
  }

  static getDownloadUrl(customerApprovalId, id, requireWatermark) {
    return apiFetch(
      `${_baseEndPoint}/${customerApprovalId}/approval-documents/${id}?requireWatermark=${requireWatermark}`
    );
  }

  static getDownloadPdf(customerApprovalId, id) {
    return apiFetch(
      `${_baseEndPoint}/${customerApprovalId}/approval-documents/${id}/pdf`,
      'GET',
      null,
      null,
      true
    );
  }
}
